import {Pagination} from '../pagination.model';
import {Request} from '../../../../requests/shared/model/request.model';

export class RequestPage extends Pagination {
  content: Request[] = [];
}
